

















































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { ShortDecimalInput } from '@/common/number';
import { DailyReportTank } from '@/models/dailyReportTank.model';
import { Tank } from '@/models/tank.model';
import { LocationStore } from '@/store/location';

@Component({
  components: {
    ShortDecimalInput,
  },
})
export default class EditPageDailyReportTankInput extends Vue {

  @Prop() disabled!: boolean;
  @Prop() readonly!: boolean;
  @Prop() tank!: Tank;
  @Prop() value!: DailyReportTank;

  @LocationStore.Bind.Getter heightUoms!: LocationStore.Getter<'heightUoms'>;
  @LocationStore.Bind.Getter temperatureUoms!: LocationStore.Getter<'temperatureUoms'>;
  @LocationStore.Bind.Getter volumeUoms!: LocationStore.Getter<'volumeUoms'>;

  @Emit('input')
  emitChange(changes: Partial <DailyReportTank>) {
    return { ...this.value, ...changes };
  }

  @Emit('focus') emitFocused() { }
  @Emit('submit') emitSubmit() { }

  setFocus(refName: string) {
    const input = this.$refs[refName] as ShortDecimalInput;
    input.focus();
  }

  focus() {
    const input = this.$refs.input1 as any;//as VTextField;
    input.focus();
  }

}
